import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-no-feedback-recipient-confirm-dialog',
  templateUrl: './no-feedback-recipient-confirm-dialog.component.html',
  styleUrls: ['./no-feedback-recipient-confirm-dialog.component.scss'],
  standalone: false,
})
export class NoFeedbackRecipientConfirmDialogComponent {
  constructor(public dialogRef: MatDialogRef<NoFeedbackRecipientConfirmDialogComponent>) {}
}
